"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowGroupCustomFormat = exports.getSelectedGroupDetails = exports.buildSelectableGroupsList = void 0;
const buildSelectableGroupsList = (workflowContext, options) => {
    // by default, remove the group that is currently authoring the form
    const { includeAuthorGroup, blacklist = [] } = options || {};
    const { groups, author } = workflowContext;
    const filteredGroups = groups.filter(group => !blacklist.includes(group.label) &&
        !(group.name && blacklist.includes(group.name)) &&
        author &&
        (includeAuthorGroup || group.label !== author.label));
    return filteredGroups;
};
exports.buildSelectableGroupsList = buildSelectableGroupsList;
const getSelectedGroupDetails = (workflowContext, label) => {
    const { groups } = workflowContext;
    return groups.find(group => group.label === label);
};
exports.getSelectedGroupDetails = getSelectedGroupDetails;
// validation
const workflowGroupCustomFormat = (workflowContext) => value => {
    // if no workflow context specified, anything is valid....
    if (!workflowContext)
        return true;
    // note: not possible yet to pass options to ajv's custom format validation...
    // so any group of the workflow would be valid
    // hence options will be usable only as interface constraints.... ¯\_(ツ)_/¯
    const validGroups = exports.buildSelectableGroupsList(workflowContext, {
        includeAuthorGroup: true
    });
    return !!validGroups.find(group => group.label === value);
};
exports.workflowGroupCustomFormat = workflowGroupCustomFormat;
//# sourceMappingURL=workflowContext.js.map